module.exports = __webpack_public_path__ + "static/img/confi-dso.e5a75e3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/confi-dso.svg
// module id = AWjK
// module chunks = 1